import React from "react";
import { NavLink } from "react-router-dom";

import './NavLinks.css';

const NavLinks = props => {
  return (
    <React.Fragment>
      {/* <div className="NavLink Message">Hoşgeldin, Ziyaretçi</div> */}
      <NavLink className="NavLink" to="/filmler">
        Filmler
      </NavLink>
      <NavLink className="NavLink" to="/diziler">
        Diziler
      </NavLink>
    </React.Fragment>
  );
};

export default NavLinks;
